import '@wangeditor/editor/dist/css/style.css' // 引入 css
import {Editor, Toolbar} from '@wangeditor/editor-for-react'
import React, {useContext, useEffect, useState} from 'react'
import {message} from 'antd';
import {sideMenuContext} from "../../../router/IndexRouter";
import {PostImage} from "./ApiMethod";
import {Arguments} from "./Arguments";
import {Boot} from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'
// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册，因此不能放在函数中。
Boot.registerModule(attachmentModule)

function WangEditor({defaultValue, placehoderText}) {
    // 向上级组件传递数据
    const {setEditorContent} = useContext(sideMenuContext);
    // editor 实例
    const [editor, setEditor] = useState(null)

    const editorConfig = {
        // 在编辑器中，点击选中“附件”节点时，要弹出的菜单
        hoverbarKeys: {
            attachment: {
                menuKeys: ['downloadAttachment'], // “下载附件”菜单
            },
        },
        // 在此处定义有哪些属性
        MENU_CONF: {},
        placeholder: placehoderText,
        defaultValue: defaultValue,
        autoFocus: true,
    }

    // 工具栏配置
    const toolbarConfig = {
        // 插入哪些菜单
        insertKeys: {
            index: 0, // 自定义插入的位置
            keys: ['uploadAttachment'], // “上传附件”菜单
        },
        toolbarKeys: [
            // "headerSelect",  //正文
            "blockquote", //引号
            "|", //分隔线
            "bold",  //加粗
            "underline",  //下划线
            "italic",   //倾斜
            // 菜单组，包含多个菜单
            {
                "key": "group-more-style",
                "title": "更多",
                "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path></svg>",
                "menuKeys": [
                    "through",
                    "code",
                    "sup",
                    "sub",
                    "clearStyle"
                ]
            },
            "color",
            "bgColor",
            "|",
            "fontSize",
            "fontFamily",
            "lineHeight",
            "|",
            "bulletedList",
            "numberedList",
            "todo",
            {
                "key": "group-justify",
                "title": "对齐",
                "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z\"></path></svg>",
                "menuKeys": [
                    "justifyLeft",
                    "justifyRight",
                    "justifyCenter",
                    "justifyJustify"
                ]
            },
            {
                "key": "group-indent",
                "title": "缩进",
                "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z\"></path></svg>",
                "menuKeys": [
                    "indent",
                    "delIndent"
                ]
            },
            "|",
            // "emotion",
            "insertLink",
            {
                "key": "group-image",
                "title": "图片",
                "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z\"></path></svg>",
                "menuKeys": [
                    "insertImage",
                    "uploadImage"
                ]
            },
            // {
            //     "key": "group-video",
            //     "title": "视频",
            //     "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z\"></path></svg>",
            //     "menuKeys": [
            //         "insertVideo",
            //         "uploadVideo"
            //     ]
            // },
            "insertTable",
            "codeBlock",
            "divider",
            "|",
            "undo",
            "redo",
            "|",
            "fullScreen"
        ]
    }


    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor === null) return;
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    // 自定义校验图片
    function customCheckImageFn(src, alt, url) {
        if (!src) {
            message.warning("请输入图片地址");
        } else if (src.indexOf('http') !== 0) {
            message.warning("图片网址必须以 http/https 开头");
        } else {
            return true
        }

        // 返回值有三种选择：
        // 1. 返回 true ，说明检查通过，编辑器将正常插入图片
        // 2. 返回一个字符串，说明检查未通过，编辑器会阻止插入。会 alert 出错误信息（即返回的字符串）
        // 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止插入。但不会提示任何信息
    }

    // 转换图片链接
    function customParseImageSrc(src) {
        if (src.indexOf('http') !== 0) {
            return `http://${src}`
        }
        return src
    }


    // 上传附件
    editorConfig.MENU_CONF['uploadAttachment'] = {

        maxFileSize: 10 * 1024 * 1024, // 10M

        onBeforeUpload(file) {
            // console.log('onBeforeUpload', file)
            return file // 上传 file 文件
            // return false // 会阻止上传
        },
        onProgress(progress) {
            // console.log('onProgress', progress)
        },
        onSuccess(file, res) {
            // console.log('onSuccess', file, res)
        },
        onFailed(file, res) {
            alert(res.message)
            // console.log('onFailed', file, res)
        },
        onError(file, err, res) {
            alert(err.message)
            console.error('onError', file, err, res)
        },

        // // 上传成功后，用户自定义插入文件
        // customInsert(res: any, file: File, insertFn: Function) {
        //   // console.log('customInsert', res)
        //   const { url } = res.data || {}
        //   if (!url) throw new Error(`url is empty`)

        //   // 插入附件到编辑器
        //   insertFn(`customInsert-${file.name}`, url)
        // },

        // 自定义上传附件
        customUpload(file, insertFn) {
            // file 即选中的文件
            // console.log('customUpload', file)
            return new Promise(resolve => {
                // 自己实现上传附件，并得到附件地址
                const postApi = Arguments.host + '/society_organization/upload/api!uploadAttachment.do';
                PostImage(postApi, file).then(res => {
                    if (res?.data.errno === 0) {
                        // console.log("data  ", res.data)
                        const attachment = res.data.data.url;
                        // 插入一个文件，模拟异步
                        setTimeout(() => {
                            insertFn(`${file.name}`, attachment)
                            resolve('ok')
                        }, 500)
                    }
                })
            })
        },

        // // 自定义选择
        // customBrowseAndUpload(insertFn: Function) {
        //   alert('自定义选择文件，如弹出图床')
        //   // 自己上传文件
        //   // 上传之后用 insertFn(fileName, link) 插入到编辑器
        // },

        // 插入到编辑器后的回调
        onInsertedAttachment(elem) {
            // console.log('inserted attachment', elem)
        },
    }


    // 插入图片
    editorConfig.MENU_CONF['insertImage'] = {
        onInsertedImage(imageNode) {
            if (imageNode === null) return;
            const {src, alt, url, href} = imageNode
            // console.log('inserted image', src, alt, url, href)
        },
        checkImage: customCheckImageFn, // 也支持 async 函数
        parseImageSrc: customParseImageSrc, // 也支持 async 函数
    }

    // 编辑图片
    editorConfig.MENU_CONF['editImage'] = {
        onUpdatedImage(imageNode) {
            if (imageNode == null) return;
            const {src, alt, url} = imageNode
            // console.log('updated image', src, alt, url)
        },
        checkImage: customCheckImageFn, // 也支持 async 函数
        parseImageSrc: customParseImageSrc, // 也支持 async 函数
    }

    // 上传图片
    editorConfig.MENU_CONF['uploadImage'] = {
        // 服务器地址，必填，自带域名+端口，使用默认的图片上传方法时使用，但存在跨域问题
        // server: Arguments.host + '/society_organization/upload/api!uploadImage.do',

        async customUpload(file, insertFn) {
            // file 即选中的文件
            // 自己实现上传，并得到图片 url alt href
            const postApi = Arguments.host + '/society_organization/upload/api!uploadImage.do';
            await PostImage(postApi, file).then(res => {
                if (res?.data.errno === 0) {
                    // 最后插入图片
                    const images = res.data.data;
                    for (let image of images) {
                        const {url, alt, href} = image
                        insertFn(url, alt, href)
                    }
                }
            })
        },

        // form-data fieldName ，需要与 PostImage 中的 key 一致，也要与 Java 中的接口参数名一致
        fieldName: 'uploadedImage',

        // 单个文件的最大体积限制，默认为 2M
        maxFileSize: 2 * 1024 * 1024,

        // 最多可上传几个文件，默认为 10
        maxNumberOfFiles: 10,

        // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
        allowedFileTypes: ['image/*'],

        // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
        // meta: {
        //     token: 'xxx',
        //     otherKey: 'yyy'
        // },

        // 将 meta 拼接到 url 参数中，默认 false
        metaWithUrl: false,

        // 自定义增加 http  header
        // headers: {
        //     Accept: 'text/x-json',
        // },

        // 是否允许跨域传递 cookie ，默认为 true
        withCredentials: true,

        // 超时时间，默认为 5 秒
        timeout: 5 * 1000, // 5 秒


        // 上传之前触发
        onBeforeUpload(file) {
            // file 选中的文件，格式如 { key: file }
            // console.log("上传图片")
            return file

            // 可以 return
            // 1. return file 或者 new 一个 file ，接下来将上传
            // 2. return false ，不上传这个 file
        },

        // 上传进度的回调函数
        onProgress(progress) {
            // progress 是 0-100 的数字
            // console.log('progress', progress)
        },

        // 单个文件上传成功之后
        onSuccess(file, res) {
            // console.log(`${file.name} 上传成功`, res)
            message.success(`${file.name} 上传成功`)
        },

        // 单个文件上传失败
        onFailed(file, res) {
            // console.log(`${file.name} 上传失败`, res)
            message.error(`${file.name} 上传失败`)
        },

        // 上传错误，或者触发 timeout 超时
        onError(file, err, res) {
            // console.log(`${file.name} 上传出错`, err, res)
            message.error(`${file.name} 上传出错：` + err)
        },
    }

    // 失去焦点的回调，比使用 onChange 的回调要节省很多计算资源，但缺点是当用户点击编辑后直接点击保存按钮，则并不触发
    // editorConfig.onBlur = (editor) => {
    //     // console.log("con   ", editor.getHtml())
    //     setEditorContent(editor.getHtml())
    // }

    return (
        <div style={{border: '1px solid #ccc', zIndex: 100}}>
            <Toolbar
                editor={editor}
                defaultConfig={toolbarConfig}
                mode="default"
                style={{borderBottom: '1px solid #ccc'}}
            />
            <Editor
                defaultConfig={editorConfig}
                value={defaultValue}
                // defaultContent={defaultValue}
                onCreated={setEditor}
                onChange={editor =>
                    setEditorContent(editor.getHtml())
                }
                mode="simple"   // 值为 default 时，选中文字会出来快捷操作栏
                style={{height: '300px', overflowY: 'hidden'}}
            />
        </div>
    )
}

export default WangEditor;